// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.echelon-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

.chart-container {
  display: flex;
  margin-right: 5px;
  background-color: white;
  padding-bottom: 5px;
  margin-bottom: 10px;
}

@media screen and (max-width: 1250px) {
  .echelon-container {
    justify-content: center;
  }
  app-lb-chart-wrapper {
    min-width: 500px;
  }
}
@media (max-width: 767px) {
  .chart-container {
    width: 86vw;
  }
  app-lb-chart-wrapper {
    min-width: 90vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/lbarometer/toolbox/lb-chart-echelon/lb-chart-echelon.component.scss"],"names":[],"mappings":"AACA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;AAAJ;;AAGA;EACI,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAAJ;;AAIA;EACE;IACE,uBAAA;EADF;EAIA;IACE,gBAAA;EAFF;AACF;AAMA;EACE;IACE,WAAA;EAJF;EAMA;IACE,eAAA;EAJF;AACF","sourcesContent":["\n.echelon-container {\n    width:100%;\n    display:flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n\n.chart-container {\n    display:flex;\n    margin-right: 5px;\n    background-color: white;\n    padding-bottom: 5px;\n    margin-bottom: 10px;\n}\n\n\n@media screen and (max-width: 1250px) {\n  .echelon-container {\n    justify-content: center;\n  }\n\n  app-lb-chart-wrapper {\n    min-width: 500px;\n  }\n\n}\n\n@media (max-width: 767px) {\n  .chart-container{\n    width:86vw\n  }\n  app-lb-chart-wrapper {\n    min-width: 90vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
